
import type { ProductDomainService } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { KpiEnum } from '../../../enums'
import { computed, defineComponent } from 'vue'
import KpiBar from '../../../components/kpi-bar.component.vue'
import CopyToClipboard from '../../../components/shared/copy-to-clipboard.component.vue'
import DefaultImage from '../../../components/shared/default-image.component.vue'
import { EpbBadge } from '../../../components/shared/epb-badge'
import { EpbText } from '../../../components/shared/epb-text'
import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'
import { ColorEnum } from '../../../enums/'

export default defineComponent({
  name: 'RelatedProductListItem',
  components: {
    CopyToClipboard,
    DefaultImage,
    EpbBadge,
    EpbText,
    KpiBar,
  },
  props: {
    item: Object,
    index: Number,
    kpi: Object as PropType<{ id: KpiEnum; percentage: number; label?: string }>,
  },
  setup(props) {
    const baseClass = 'related-product-list-item'
    const productService = CONTAINER.get<ProductDomainService>(TYPES.ProductDomainService)

    const imageUrl = computed(() => {
      return productService.getProductImageUrl(props.item.id)
    })

    return {
      baseClass,
      imageUrl,
      ColorEnum,
    }
  },
})
